<template>
  <div id="app">
    <AppLayout>
      <router-view />
    </AppLayout>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {
  },
  data: function () {
    return {

    };
  },

  mounted: function () {

  },
  computed: {

  },
  methods: {

  },
};
</script>
<style lang="scss">
</style>
